export default {
    handle: (msg) => {}
}
